
import { Component, Vue, Prop } from "vue-property-decorator";
import { OrderIntakeDto } from "@/dtos/orderIntakeDto";

@Component({
	components: {},
})
export default class RegionTotals extends Vue {
	@Prop()
	private countryCode!: string;
	@Prop()
	private currency!: string;
	@Prop()
	private orders!: OrderIntakeDto[];

	private get regionNameFromCountryCode(): string {
		return this.$store.getters.regionNameFromCountryCode(this.countryCode);
	}

	private get title(): string {
		switch (this.countryCode) {
			case "CH":
				return "Schweiz";
			case "DE":
				return "Deutschland";
			case "AT":
				return "Österreich";
			default:
				return "N/A";
		}
	}

	private get regionOrders(): OrderIntakeDto[] {
		return this.orders.filter(
			(o: OrderIntakeDto) => o.region == this.regionNameFromCountryCode
		);
	}

	private get orderAmount(): number {
		return this.regionOrders.length;
	}

	private get totalPortal() {
		let totalMoney = 0;
		for (const order of this.regionOrders) {
			totalMoney += Math.round((order.totalAmount + Number.EPSILON) * 100) / 100;
		}
		return totalMoney;
	}

	private get distinctCustomerCount() {
		const distinctIds = [...new Set(this.regionOrders.map((o) => o.customerId))];
		return distinctIds.length;
	}
}
